import { render, staticRenderFns } from "./RecetaFormulario.vue?vue&type=template&id=881854d4"
import script from "./RecetaFormulario.vue?vue&type=script&lang=js"
export * from "./RecetaFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports